<template>
  <div class="dvQuickGlance-image">
    <div class="dvQuickGlance-image-placer flexCenterAll"><span class="icon-fs_user"></span></div>

    <img class="dvQuickGlance-image-pic responsive-img" :src="this.$store.getters.getCurrentUserPhoto" v-show="this.$store.getters.getCurrentUserPhoto.length > 0"/>

    <div v-show="imgUploading" class="dvLoader-image">
      <v-progress-circular
        :size="40"
        :width="3"
        color="#CCCCCC"
        indeterminate
      ></v-progress-circular>
    </div>

    <input v-show="false" type="file" id="file" ref="file" v-on:change="onChangeFileUpload()" accept="image/png, image/jpeg"/>
    <a
      @click="clickFile()"
      class="dvQuickGlance-image-link flexCenterAll" href="javascript:void(0)"><span class="icon-editor_camera"></span></a>
    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
  </div> <!-- dvQuickGlance-image -->
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'

  export default {
    name: 'img-uploader',
    data: () => ({
      file: '',
      imgUploading: false,
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      }
    }),
    computed: {

    },
    methods: {
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      clickFile (){
        let file = document.getElementById('file');
        file.click()
      },
      onChangeFileUpload (){
        this.file = this.$refs.file.files[0];
        this.imgUploading = true

        let self = this

        let formData = new FormData();
        formData.append('file', this.file);


        this.$http.secured.post('api/users/change-my-pic',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            this.$store.commit('setCurrentUserPhoto', { photo: response.data.photo })
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(', '), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }            
          })
          .then(function () {
            self.imgUploading = false
          })


      }
    },
    mounted() {
    },
    created () {
    },
    components: {
      SnackBar
    }
  }



</script>
